import { render, staticRenderFns } from "./ComboMultiple.vue?vue&type=template&id=2ca4f82d"
import script from "./ComboMultiple.vue?vue&type=script&lang=js"
export * from "./ComboMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports